import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { PersonalSettings } from '../../myceres/components/settingsv2/custom-filter/custom-filter';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private rendererFactory = inject(RendererFactory2);
    private overlay = inject(OverlayContainer);
    private translateService = inject(TranslateService);

    private darkMode = new BehaviorSubject<boolean>(false);
    darkMode$ = this.darkMode.asObservable();
    private renderer: Renderer2;

    constructor() {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    public applySettings(settings: PersonalSettings) {
        if (settings) {
            this.translateService.use(settings.defaultLanguage);
            this.setTheme(settings);
        } else {
            this.translateService.use('en');
            this.setSystemTheme();
        }
    }

    public setTheme(settings: PersonalSettings) {
        if (settings.defaultTheme === 'dark') {
            this.setDarkMode();
        } else if (settings.defaultTheme === 'light') {
            this.setLightMode();
        } else {
            this.setSystemTheme();
        }
    }

    public setDarkMode() {
        this.darkMode.next(true);
        this.renderer.setAttribute(document.body, 'data-theme', 'dark');
        this.overlay.getContainerElement().setAttribute('data-theme', 'dark');
    }

    public setLightMode() {
        this.darkMode.next(false);
        this.renderer.setAttribute(document.body, 'data-theme', '');
        this.overlay.getContainerElement().setAttribute('data-theme', '');
    }

    public setSystemTheme(): void {
        const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        if (prefersDarkMode) {
            this.setDarkMode();
        } else {
            this.setLightMode();
        }
    }
}
